const config = {
    API_BASE_URL: 'https://f8499944a6a3.ngrok.app',
  };
  
  export default config;
